export default __webpack_public_path__ + "static/media/home-hover.e7629870.svg";